import { getStockPermissions } from "../../../services/auth/permission";

export default {
    namespaced: true,
    state: {
        item: {
            list: false,
            read: true,
            create: false,
            update: false,
            delete: false
        },
        measureUnit: {
            list: false,
            read: false,
            create: false,
            update: false,
            delete: false
        },
        warehouse: {
            list: true,
            read: true,
            create: true,
            update: true,
            delete: true
        },
        itemGroup: {
            list: false,
            read: true,
            create: false,
            update: false,
            delete: false
        },
        reports: {
            movement: true,
            onHandByItem: true,
            onHandByWarehouse: true
        }
    },
    getters: {
        item: state => state.item,
        measureUnit: state => state.measureUnit,
        warehouse: state => state.warehouse,
        itemGroup: state => state.itemGroup,
        reports: state => state.reports
    },
    mutations: {
        set(state, payload) {
            state.item = payload.items;
            state.measureUnit = payload.measure_unit;
            state.warehouse = payload.warehouses;
            state.itemGroup = payload.item_groups;
            state.reports = payload.reports;
        }
    },
    actions: {
        async get(context) {
            return new Promise((resolve, reject) => {
                getStockPermissions()
                    .then(
                        r => {
                            context.commit("set", r.data)
                            resolve(r)
                        }
                    )
                    .catch(
                        e => reject(e)
                    )
            });
        }
    }
}